const actions = {
  FETCH_USERS: 'FETCH_USERS',
  FETCH_USERS_SUCCESS: 'FETCH_USERS_SUCCESS',
  FETCH_USER: 'FETCH_USER',
  FETCH_USER_SUCCESS: 'FETCH_USER_SUCCESS',
  SELECT_USER: 'SELECT_USER',
  EDIT_USER: 'EDIT_USER',
  ADD_USER: 'ADD_USER',
  EDIT_VIEW: 'EDIT_VIEW',
  SAVE_USER: 'SAVE_USER',
  SAVE_USER_SUCCESS: 'SAVE_USER_SUCCESS',
  SAVE_USER_ERROR: 'SAVE_USER_ERROR',
  INACTIVATE_USER: 'INACTIVATE_USER',
  INACTIVATE_USER_SUCCESS: 'INACTIVATE_USER_SUCCESS',
  FETCH_ALL_PERMISSIONS: 'FETCH_ALL_PERMISSIONS',
  FETCH_ALL_PERMISSIONS_SUCCESS: 'FETCH_ALL_PERMISSIONS_SUCCESS',
  TOGGLE_INACTIVE: 'TOGGLE_INACTIVE',
  EDIT_USER_VIEW: 'EDIT_USER_VIEW',
  CHECK_USER_EMAIL: 'CHECK_USER_EMAIL',
  CHECK_USER_EMAIL_SUCCESS: 'CHECK_USER_EMAIL_SUCCESS',
  UPDATE_USER_INFO: 'UPDATE_USER_INFO',
  FETCH_FACILITIES: 'FETCH_FACILITIES',
  FETCH_FACILITIES_SUCCESS: 'FETCH_FACILITIES_SUCCESS',
  fetchUsers: ({clientId = '', showInactive = false}) => ({
    type: actions.FETCH_USERS,
    clientId,
    showInactive
  }),
  fetchUsersSuccess: (users) => ({
    type: actions.FETCH_USERS_SUCCESS,
    users,
  }),
  fetchUser: (userId, clientId) => ({
    type: actions.FETCH_USER,
    userId,
    clientId
  }),
  fetchUserSuccess: (user) => ({
    type: actions.FETCH_USER_SUCCESS,
    user: user
  }),
  fetchAllPermissions: ({scope = null}) => ({
    type: actions.FETCH_ALL_PERMISSIONS,
    scope
  }),
  fetchAllPermissionsSuccess: (permissions) => ({
    type: actions.FETCH_ALL_PERMISSIONS_SUCCESS,
    permissions
  }),
  selectUser: (userId) => ({
    type: actions.SELECT_USER,
    userId
  }),
  addUser: (view = false) => ({
    type: actions.ADD_USER,
    view
  }),
  editUserView: (view = false) => ({
    type: actions.EDIT_USER_VIEW,
    view
  }),
  editUser: (view = false) => ({
    type: actions.EDIT_USER,
    view
  }),
  toggleInactive: (toggle) => ({
    type: actions.TOGGLE_INACTIVE,
    toggle
  }),
  checkUserEmail: (email, clientId) => ({
    type: actions.CHECK_USER_EMAIL,
    email,
    clientId
  }),
  checkUserEmailSuccess: (user) => ({
    type: actions.CHECK_USER_EMAIL_SUCCESS,
    user
  }),
  updateUserInfo: (userInfo) => ({
    type: actions.UPDATE_USER_INFO,
    userInfo
  }),
  saveUser: (userInfo, clientId) => ({
    type: actions.SAVE_USER,
    clientId,
    userInfo
  }),
  saveUserSuccess: (userInfo) => ({
    type: actions.SAVE_USER_SUCCESS,
    userInfo
  }),
  inactivateUser: () => ({
    type: actions.INACTIVATE_USER,
  }),
  inactivateUserSuccess: () => ({
    type: actions.INACTIVATE_USER_SUCCESS,
  }),
  fetchFacilities: (parentId) => ({
    type: actions.FETCH_FACILITIES,
    parentId,
  }),
  fetchFacilitiesSuccess: (facilities) => ({
    type: actions.FETCH_FACILITIES_SUCCESS,
    facilities,
  })

};
export default actions;
